import React from "react";
import { Icon } from "@jsq/ds/icons";
import * as styles from "./styles_vanilla.css";

export function ReadOnlyChip() {
  return (
    <span className={styles.roLabel}>
      <Icon type="lock" size="small" /> read-only
    </span>
  );
}
